export const getData = async function getData(url) {
    try {
        const response = await fetch(url, {
            method: "GET",
            referrerPolicy: "no-referrer",
            headers: {
                "Content-Type": "application/json",
                'Cache-Control': 'no-cache',
            },
            credentials: "include",
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Something went wrong');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};
